<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-26 15:09:16
-->
<template>
  <div class="box">
    <div style="display: flex;width:100%">
      <div class="left">
        <div style="font-weight: 600;" class="title">友链分组</div>
        <div class="search">
          <a-input-search
            v-model:value="value"
            placeholder="搜索分类"
            size="large"
            @search="onSearch"
          >
            <template #enterButton>
              <img class="img" src="@/assets/images/search.jpg" />
            </template>
          </a-input-search>
        </div>
        <a-spin :spinning="leftLoading">
              <div class="tree-box">
          <div
            @click="selectItem(item)"
            :class="item.id == selectGroupItem.id ? 'select-item' : ''"
            class="one"
            v-for="(item, index) in grouplist"
          >
            <div style="display: flex">
              <div :class="item.id == selectGroupItem.id ? 'title-icon' : ''">
                <span class="icon-link-m"></span>
              </div>
              <div
                :style="{
                  color: item.id == selectGroupItem.id ? '#409EFF' : '',
                }"
                class="title-name"
              >
                <span :title="item.groupName">{{ item.groupName }}</span>
              </div>
            </div>
            <div>
              <a-popover placement="bottomRight">
                <template slot="content">
                  <a v-if="codeData.indexOf('148') != -1" @click="enitItem(item)" style="cursor: pointer"
                    >编辑分类</a
                  >
                  <div
                   v-if="codeData.indexOf('149') != -1"
                    @click="delGroupOpen(item)"
                    style="
                      color: rgba(245, 108, 108, 1);
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    删除分类
                  </div>
                </template>
                <i class="el-icon-more fixed-inner"></i>
              </a-popover>
            </div>
          </div>
        </div>
        </a-spin>
        
        <div v-if="codeData.indexOf('150') != -1" @click="addAdminFn" class="add-group">
          <span>+ </span><span>添加分组</span>
          <div class="add-dir"></div>
        </div>
      </div>
      <div class="middle"></div>
      <div class="right">
        <div class="right-name">友链清单-{{ selectGroupItem.groupName }}</div>
        <div class="top">
          <div>
            <el-button style="margin-right:2px" v-if="codeData.indexOf('88') != -1" @click="addLian" type="primary"
              >新增链接</el-button
            >
            <el-button
              v-if="codeData.indexOf('89') != -1"
              style="background: #ecf5ff; color: #176de6;"
              type="primary"
              @click="batchDel"
              >批量删除</el-button
            >
          </div>
          <div class="search">
            <a-input
              style="width: 170px; margin-right: 12px"
              v-model:value="searchVariableName"
              placeholder="按链接名称搜索"
            />
            <el-button @click="search" type="primary">查询</el-button>
          </div>
        </div>
        <a-spin :spinning="loading">
              <coententTable
          :y="height"
          @handleSizeChange="handleSizeChange"
          @onShowSizeChange="onShowSizeChange"
          :columns="type == 1 ? columns : columnsTwo"
          :dataSource="dataSource"
          :customSlot="customSlot"
          @selectedRowKeys="selectedRowKeys"
          :isSelectRow="true"
          :rowKeys="rowKeys"
        >
          <template v-slot:sort="scopeVal">
            <div class="sort">
              <div class="sort-box">
                 <div  class="sort-two" v-if="codeData.indexOf('216') != -1" @click="sort(scopeVal.scope, true)">
                    <i   class="ri-arrow-up-line"></i>
                </div>
              </div>
              <input
                disabled
                v-model="scopeVal.scope.sort"
                class="sort-style"
              />
              <div class="sort-box-two">
                <div  class="sort-two" v-if="codeData.indexOf('216') != -1" @click="sort(scopeVal.scope, false)">
                   <i  class="ri-arrow-down-line"></i>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:operation="scopeVal">
             <div style="display: flex">
                  <div  class="btnTwo" style="margin-right: 14px"  v-if="codeData.indexOf('90') != -1" @click="permissionManagement(scopeVal.scope)">编辑</div>
                  <div
                    v-if="codeData.indexOf('91') != -1"
                    @click="open(scopeVal.scope)"
                    class="btnThree"
                    >删除</div
                  >
             </div>
          </template>
        </coententTable>
        </a-spin>
         <div class="pagination" v-if="pagination.total > 0">
                <a-pagination
                    :current="pagination.current"
                    :pageSize="pagination.pageSize"
                    show-size-changer
                    show-quick-jumper
                    :total="pagination.total"
                    @change="onShowSizeChange"
                    @showSizeChange="handleSizeChange"
                    :page-size-options="pagination.pageSizeOptions"
                    :show-total="(total) => `共 ${pagination.total} 条`"
                />
            </div>
      </div>
    </div>
    <addCustom @closeTwo="closeTwo" :item="item" @close="close" :visible="visible"></addCustom>
    <el-dialog
      :title="ruleForm.id ? '编辑友链' : '新增友链'"
      :visible.sync="dialogVisible"
      width="600px"
      top="17%"
      class="column-box"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="友链名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入友链名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="友链地址" prop="url">
          <el-input
            v-model="ruleForm.url"
            placeholder="请输入友链地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">取 消</el-button>
        <el-button v-repeatClick size="medium" :loading="loadingBtn" type="primary" @click="addLinksFn">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认删除友链?"
      :visible.sync="deleteVariableShow"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVariableShow = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="deleteVariable">确认删除</el-button>
      </span>
    </el-dialog>
     <el-dialog
      title="确认删除友链?"
      :visible.sync="deleteVariableShowTwo"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVariableShowTwo = false">取消</el-button>
        <el-button :loading="deleteShowTwo" type="danger" @click="queDelBatch">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认删除友链分组?"
      :visible.sync="deleteGroupShow"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteGroupShow = false">取消</el-button>
        <el-button :loading="deleteShowGroup" type="danger" @click="delGroup">确认删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import addCustom from "./add_custom_vanables.vue";
import {
  list,
  del,
  addLinks,
  listLinks,
  updateSort,
  updateLink,
  delLink,
  delBatch,
} from "./custom_variables";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      value: "",
      type: 1,
      height: 0,
      isCloseAll: false,
      deleteGroupShow:false,
      deleteVariableShowTwo:false,
      loading:false,
      expandedKeys: [],
      selectedKeys: [],
      loadingBtn:false,
      treeData: [],
      organization: "1",
      role: undefined,
      value: "",
      columns: [
        {
          title: "名称",
          dataIndex: "name",
          ellipsis: true,
           customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        }
        },
        {
          title: "链接",
          dataIndex: "url",
          ellipsis: true,
          width: 300,
        },
        {
          title: "排序",
          dataIndex: "sort",
          scopedSlots: { customRender: "sort" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 174,
        },
      ],
      customSlot: [
        {
          name: "name",
          customRender: "name",
        },
        {
          name: "sort",
          customRender: "sort",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      visible: false,
      grouplist: [],
      item: {},
      leftLoading: false,
      dialogVisible: false,
      ruleForm: {},
      rules: {
        name: [{ required: true, message: "请输入友链名称", trigger: "blur" }],
        url: [{ required: true, message: "请输入友链地址", trigger: "blur" }],
      },
      selectGroupItem: {},
      searchVariableName: "",
      deleteVariableShow: false,
      linkItem: {},
      groupItem:{},
      rowKeys: [],
      codeData:[],
      deleteShow:false,
      deleteShowTwo:false,
      deleteShowGroup:false,
    };
  },
  components: {
    coententTable,
    addCustom,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    //this.getVariableList();
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$refs.ruleForm.clearValidate();
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    deleteVariable() {
      this.deleteShow = true;
      delLink({
        id: this.linkItem.id,
      }).then((res) => {
        if (res.code == 0) {
          this.deleteVariableShow = false;
          this.deleteShow = false;
          this.getVariableList();
        }
      });
    },
    open(item) {
      this.deleteVariableShow = true;
      this.linkItem = item;
    },
    permissionManagement(item) {
      this.ruleForm = JSON.parse(JSON.stringify( item));
      this.dialogVisible = true;
    },
    sort(item, type) {
      updateSort({
        id: item.id,
        type,
      }).then((res) => {
        if (res.code == 0) {
          this.getVariableList();
        }
      });
    },
    batchDel() {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return;
      }
      this.deleteVariableShowTwo = true;
    },
    queDelBatch(){
      this.deleteShowTwo = true;
      delBatch({
        ids: this.rowKeys,
        groupId: this.selectGroupItem.id,
      }).then((res) => {
        if (res.code == 0) {
           this.deleteVariableShowTwo = false;
           this.deleteShowTwo = false;
           this.rowKeys = [];
          this.getVariableList();
        }
      });
    },
    search() {
      this.pagination.current = 1;
      this.getVariableList();
    },
    //获取列表
    getVariableList() {
      const _this = this;
      this.loading = true;
      let reqData = {
        current: _this.pagination.current,
        groupId: _this.selectGroupItem.id || "",
        siteId: sessionStorage.getItem("siteId"),
        size: _this.pagination.pageSize,
        name: _this.searchVariableName,
      };
      listLinks(reqData).then((res) => {
        if (res.code == 0) {
          _this.dataSource = res.data.records;
          _this.pagination.total = res.data.total;
           this.height = 0;
          if(_this.pagination.total > 0){
            this.height = document.documentElement.clientHeight - 390;
            window.onresize = () => {
                return (() => {
                  this.height = document.documentElement.clientHeight - 390;
                })();
              };
          }
          _this.pagination.current = res.data.current;
          if(_this.pagination.current !=1 && _this.dataSource.length == 0){
                _this.pagination.current--
                _this.getVariableList()
            }
        }
        this.loading = false;
      });
    },
    addLinksFn() {
      this.loadingBtn = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.ruleForm.id) {
            updateLink({
              ...this.ruleForm,
              groupId: this.selectGroupItem.id,
            }).then((res) => {
              if (res.code == 0) {
                this.dialogVisible = false;
                this.$refs.ruleForm.clearValidate();
                this.getVariableList();
              }
               this.loadingBtn = false;
            });
          } else {
            addLinks({
              ...this.ruleForm,
              groupId: this.selectGroupItem.id,
            }).then((res) => {
              if (res.code == 0) {
                this.dialogVisible = false;
                this.$refs.ruleForm.clearValidate();
                this.getVariableList();
              }
              this.loadingBtn = false;
            });
          }
        } else {
          this.loadingBtn = false;
        }
      });
    },
    addLian() {
      if (!this.selectGroupItem.id) {
        message.error("请选择分组");
      } else {
        this.ruleForm = {
          name: "",
          url: "",
          siteId: sessionStorage.getItem("siteId"),
        };
        this.dialogVisible = true;
      }
    },
    selectItem(item) {
      this.selectGroupItem = item;
      this.getVariableList();
    },
    delGroupOpen(item){
        this.groupItem = item
        this.deleteGroupShow =true
    },
    delGroup() {
      this.deleteShowGroup = true;
      del({
        id: this.groupItem.id,
      }).then((res) => {
        if (res.code == 0) {
            this.deleteGroupShow =false;
             this.deleteShowGroup = false;
          this.getList();
          this.getVariableList();
        }
      });
    },
    close() {
      this.visible = false;
      this.getList();
    },
    closeTwo(){
       this.visible = false;
    },
    enitItem(item) {
      this.visible = true;
      this.item = item;
    },
    addAdminFn() {
      this.visible = true;
      this.item = {};
    },
    onSearch() {
      this.getList();
    },
    // 切换 搜索
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getVariableList();
    },
    handleSizeChange(page,pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getVariableList();
    },
    getList() {
      this.leftLoading = true;
      list({
        siteId: sessionStorage.getItem("siteId"),
        groupName: this.value,
      }).then((res) => {
        this.grouplist = res.data;
        if (res.data.length == 0) {
          this.grouplist = [];
        } else {
          this.selectGroupItem = res.data[0];
          this.getVariableList();
        }
        this.leftLoading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  width: 100%;
  height: calc(90% - 11px);
  .left {
    width: 250px;
    //height: calc(113% - 7px);
    font-size: 14px;
    color: #000;
    padding: 24px;
    //position: relative;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    font-size: 14px;
    padding-top: 24px;
    //border-left: solid 2px #f2f3f5;
    padding-bottom: 33px;
    width: 500px;
    .right-name {
      padding-left: 24px;
      color: #000;
      font-weight: 600;
    }
    .log-box {
      //border-bottom: solid 1px #dcdfe6;
      display: flex;
      margin-left: 24px;
      margin-right: 24px;
      margin-top: 24px;
      .log {
        padding: 10px 20px;
        border-top: solid 1px #dcdfe6;
        border-left: solid 1px #dcdfe6;
        cursor: pointer;
        border-bottom: solid 1px #dcdfe6;
      }
      .log:last-child {
        border-right: solid 1px #dcdfe6;
        border-top-right-radius: 10px;
      }
      .log:first-child {
        border-top-left-radius: 10px;
      }
    }
    .search {
      display: flex;
      /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
    }
    /deep/ .pagination {
      //bottom: -120px !important;
    }
  }
}
.top {
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 254px;
  }

  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
/deep/ .ant-tree {
  max-height: 630px;
  overflow: hidden;
  overflow-y: auto;
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 330px;
  margin-right: 24px;
  margin-top: -1px;
}
.middle {
  height: calc(113% - 4px);
  width: 1px;
  background: #f4f4f6;
}
.tr-one {
  display: flex;
}
.quan {
  width: 24px;
  height: 24px;
  background: #fff;
  border: solid 1px #ccc;
  border-radius: 50%;
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.one {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  border-radius: 4px;
}
.fixed-inner {
  transform: rotate(90deg);
  cursor: pointer;
}
.title-name {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto-regular;
  margin-left: 10px;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  width: 140px;
}
.add-group {
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  background-color: rgba(64, 158, 255, 1);
  text-align: center;
  color: #fff;
  font-weight: 500;
  width: 200px;
  position: absolute;
  bottom: 10px;
  cursor: pointer;
  z-index: 2;
}
.tree-box {
  //display: flex;
  min-height: 300px;
  align-content: space-between;
}
.fixed-inner:hover {
}
.eidt-ground {
}
/deep/ .el-dialog__body {
  padding-bottom: 0px;
}
.select-item {
  background-color: rgba(236, 245, 255, 1);
}
.title-icon {
  .icon-link-m:before {
    color: rgba(64, 158, 255, 1);
  }
}
.add-dir {
  position: absolute;
  top: -14px;
  height: 10px;
  background: #fff;
  width: 249px;
  z-index: 2;
  left: -23px;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 58px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  justify-content: right;
  border-top: solid #f4f4f6 2px;
  position: absolute;
  bottom: 0;
  width: calc(100% - 250px);
  padding-right: 24px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
/deep/ .ant-spin-nested-loading{
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
 .el-button--primary {
  background: #176de6;
}
.sort-two{
   display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
.column-box{
  /deep/ .el-dialog__body{
   padding-top: 20px;
 }
  /deep/ .el-dialog__title {
    color: #000;
    font-size: 18px;
    font-weight: 600;
  }
  /deep/ .el-dialog__close{
    font-size: 18px;
    font-weight: 600;
  }
}
</style>